<script setup>
import { Icon } from '@iconify/vue';

defineProps({
  job: { type: Object, required: true },
  cachedUrl: { type: String, default: '' },
  isBookmarked: { type: Boolean, default: false },
  timeAgo: { type: String, required: true },
  salary: { type: String, required: true },
});

defineEmits(['bookmark']);
</script>

<template>
  <div class="flex flex-col sm:hidden w-full">
    <div class="flex items-start justify-between mb-2">
      <span
        class="bg-blue-50 dark:bg-blue-900 text-blue-700 dark:text-blue-300 text-[11px] font-bold px-1.5 py-0.5 rounded tracking-wider uppercase"
        >{{ job.tipe_pekerjaan }}</span
      >
      <button
        @click.prevent="$emit('bookmark')"
        class="transition-colors"
        :class="
          isBookmarked
            ? 'text-blue-600 dark:text-blue-400'
            : 'text-gray-400 dark:text-gray-500 hover:text-blue-600 dark:hover:text-blue-400'
        "
      >
        <Icon :icon="isBookmarked ? 'mdi:bookmark' : 'mdi:bookmark-outline'" class="w-5 h-5" />
      </button>
    </div>

    <div class="flex items-start gap-3 mb-2">
      <div
        class="w-12 h-12 bg-white dark:bg-gray-700 rounded-lg shadow-sm border border-gray-100 dark:border-gray-600 flex items-center justify-center p-1.5 shrink-0 self-center"
      >
        <img
          v-if="job.logo_perusahaan && cachedUrl"
          :src="cachedUrl"
          :alt="job.nama_perusahaan"
          class="w-full h-full object-contain"
          loading="lazy"
        />
        <span v-else class="text-xl font-bold text-[#293146] dark:text-gray-200">{{
          job.nama_perusahaan?.charAt(0)
        }}</span>
      </div>
      <div class="min-w-0 pt-0.5 flex flex-col justify-center h-12">
        <h3
          class="font-bold text-[17px] text-gray-900 dark:text-white leading-tight truncate group-hover:text-slate-800 dark:group-hover:text-[#C5B47A] transition-colors"
        >
          {{ job.judul_pekerjaan }}
        </h3>
        <p
          class="text-sm text-gray-600 dark:text-gray-300 font-medium truncate group-hover:text-slate-800 dark:group-hover:text-[#C5B47A] transition-colors mt-0.5"
        >
          {{ job.nama_perusahaan }}
        </p>
      </div>
    </div>

    <div class="space-y-1 text-[13px] text-gray-600 dark:text-gray-300 mb-2 grow min-w-0">
      <div class="flex items-center min-w-0">
        <Icon
          icon="mdi:map-marker-outline"
          class="w-4 h-4 mr-1.5 text-gray-400 dark:text-gray-500 shrink-0"
        />
        <span class="truncate">{{ job.lokasi_penempatan }}</span>
      </div>
      <div class="flex items-center min-w-0">
        <Icon
          icon="mdi:account-outline"
          class="w-4 h-4 mr-1.5 text-gray-400 dark:text-gray-500 shrink-0"
        />
        <span class="truncate">{{ job.jenis_kelamin }}</span>
      </div>
      <div class="flex items-center text-emerald-600 dark:text-emerald-400 font-semibold min-w-0">
        <Icon icon="mdi:cash-multiple" class="w-4 h-4 mr-1.5 shrink-0" />
        <span class="truncate">{{ salary }}</span>
      </div>
    </div>

    <div
      class="flex items-center justify-between pt-2 border-t border-gray-100 dark:border-gray-700 mt-auto"
    >
      <div class="flex items-center text-xs text-gray-400 dark:text-gray-500">
        <Icon icon="mdi:clock-outline" class="w-3.5 h-3.5 mr-1" />
        <span>{{ timeAgo }}</span>
      </div>
      <span
        class="bg-[#293146] dark:bg-[#C5B47A] text-white dark:text-gray-900 font-bold rounded text-xs px-2 py-0.5 hover:bg-[#3b4660] dark:hover:bg-[#C5B47A] transition-all shadow-sm"
      >
        {{ $t('home.applyBtn') }}
      </span>
    </div>
  </div>
</template>
